import { type TemplateWithoutSections } from 'src/data-capture/hooks/templates/useTemplates';

const toFriendlyLabel = (fileName?: string): string | undefined => {
  if (!fileName) return undefined;
  const base = fileName.replace(/\.[^/.]+$/, '');
  const spaced = base.replace(/[_-]+/g, ' ').toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const labelFromTemplate = (template?: TemplateWithoutSections): string | undefined => {
  if (!template) return undefined;
  const name = template.displayName?.trim();
  if (name) return name;
  return toFriendlyLabel(template.file?.fileName);
};

export const labelFromReportType = (reportType: string): string =>
  reportType
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
